import React from "react";
import styled from "styled-components";

interface IProps {
	width?: number;
	height?: number;
	color?: string;
	onClick?: () => void;
}

const SVG = styled.svg``;

export const IconInjury: React.FC<IProps> = ({color, ...rest}) => (
	<SVG viewBox="0 0 16 16" fill="none" {...rest}>
		<g transform="translate(-2.000000, -2.000000)">
			<circle pointerEvents="none" id="Oval" fill="#DE0000" cx="10" cy="10" r="8" />
			<path
				pointerEvents="none"
				d="M9.5,14 L9.5,9 L10.5,9 L10.5,14 L9.5,14 Z M9,7 L10,6 L11,7 L10,8 L9,7 Z"
				fill="#FFFFF0"
				fillRule="nonzero"
				transform="translate(10.000000, 10.000000) rotate(180.000000) translate(-10.000000, -10.000000) "
			/>
		</g>
	</SVG>
);

IconInjury.defaultProps = {
	width: 16,
	height: 16,
	color: "currentColor",
};
